(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["image-with-text-advanced"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initSliders(root) {
      (root || document).querySelectorAll('[data-iwt-slider]').forEach(function (el) {
        if (el.dataset.iwtBound) return;
        el.dataset.iwtBound = '1';
        var track = el.querySelector('[data-iwt-track]');
        if (!track) return;
        var dots = el.querySelectorAll('.iwt__slider-dots span');
        var count = track.children.length;
        function current() { return Math.round(track.scrollLeft / Math.max(1, track.clientWidth)); }
        function go(i) { i = (i + count) % count; track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' }); }
        var raf;
        track.addEventListener('scroll', function () {
          cancelAnimationFrame(raf);
          raf = requestAnimationFrame(function () {
            var c = current();
            dots.forEach(function (d, n) { d.classList.toggle('is-active', n === c); });
          });
        }, { passive: true });
        var prev = el.querySelector('[data-iwt-prev]');
        var next = el.querySelector('[data-iwt-next]');
        if (prev) prev.addEventListener('click', function () { go(current() - 1); });
        if (next) next.addEventListener('click', function () { go(current() + 1); });
      });
    }

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-iwt-copy]');
      if (!btn) return;
      var id = btn.getAttribute('data-iwt-copy');
      var done = function () { btn.textContent = 'Copied: ' + id; };
      if (navigator.clipboard) { navigator.clipboard.writeText(id).then(done, done); } else { done(); }
    });

    document.addEventListener('shopify:section:load', function (e) { initSliders(e.target); });
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', function () { initSliders(); }); } else { initSliders(); }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ingredients"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var mq = window.matchMedia('(max-width: 749px)');

    function sync() {
      document.querySelectorAll('[data-ingr-accordion]').forEach(function (group) {
        var active = mq.matches && group.classList.contains('ingr-grid--accordion');
        group.querySelectorAll('[data-ingr]').forEach(function (card) {
          var btn = card.querySelector('[data-ingr-toggle]');
          if (!btn) return;
          var open = !active || card.classList.contains('is-open');
          btn.setAttribute('aria-expanded', open ? 'true' : 'false');
          if (active) {
            btn.removeAttribute('tabindex');
            btn.removeAttribute('aria-disabled');
          } else {
            btn.setAttribute('tabindex', '-1');
            btn.setAttribute('aria-disabled', 'true');
          }
        });
      });
    }

    function toggle(card) {
      var group = card && card.closest('.ingr-grid--accordion');
      if (!group || !mq.matches) return;
      var willOpen = !card.classList.contains('is-open');
      group.querySelectorAll('[data-ingr].is-open').forEach(function (c) { c.classList.remove('is-open'); });
      if (willOpen) card.classList.add('is-open');
      sync();
    }

    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-ingr-toggle], [data-ingr-media]');
      if (trigger) toggle(trigger.closest('[data-ingr]'));
    });

    /* Theme editor: open the block you select in the sidebar */
    document.addEventListener('shopify:block:select', function (e) {
      var card = e.target.closest && e.target.closest('[data-ingr]');
      if (card && !card.classList.contains('is-open')) toggle(card);
    });
    document.addEventListener('shopify:section:load', sync);

    if (mq.addEventListener) { mq.addEventListener('change', sync); } else { mq.addListener(sync); }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', sync); } else { sync(); }
  })();

  } catch(e) { console.error(e); }
})();
})();
